module.exports = __webpack_public_path__ + "media/images/area/feature/hokkaido/05-8d11a7ef8e65c96e838c5cf3bc920054.jpg";